/* ortaglia – Relaunch One-Page */
(function () {
  "use strict";

  /* ---------- Header: Schatten beim Scrollen ---------- */
  var header = document.querySelector(".site-header");

  function onScroll() {
    header.classList.toggle("is-scrolled", window.scrollY > 8);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile-Navigation ---------- */
  var navToggle = document.getElementById("nav-toggle");
  var mainNav = document.getElementById("main-nav");

  function closeNav() {
    document.body.classList.remove("nav-open");
    navToggle.setAttribute("aria-expanded", "false");
    navToggle.setAttribute("aria-label", "Menü öffnen");
  }

  navToggle.addEventListener("click", function () {
    var open = document.body.classList.toggle("nav-open");
    navToggle.setAttribute("aria-expanded", String(open));
    navToggle.setAttribute("aria-label", open ? "Menü schließen" : "Menü öffnen");
  });

  mainNav.addEventListener("click", function (event) {
    if (event.target.closest("a")) closeNav();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeNav();
  });

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Überschriften: Buchstaben fürs Highlight vorbereiten ---------- */
  function splitHeadingLetters(el) {
    // Originaltext als Label erhalten, damit Screenreader nicht buchstabieren
    var label = "";
    Array.prototype.forEach.call(el.childNodes, function (node) {
      label += node.nodeType === 3 ? node.textContent : " ";
    });
    el.setAttribute("aria-label", label.replace(/\s+/g, " ").trim());

    var nodes = Array.prototype.slice.call(el.childNodes);
    var index = 0;
    nodes.forEach(function (node) {
      if (node.nodeType !== 3) return; // <br> bleibt erhalten
      var frag = document.createDocumentFragment();
      node.textContent.split("").forEach(function (ch) {
        if (ch === " " || ch === "\u00a0") {
          frag.appendChild(document.createTextNode(ch));
        } else {
          var span = document.createElement("span");
          span.className = "char";
          span.setAttribute("aria-hidden", "true");
          span.style.setProperty("--ci", index);
          span.textContent = ch;
          frag.appendChild(span);
          index++;
        }
      });
      el.replaceChild(frag, node);
    });
  }

  // Das Buchstaben-Highlight ist ein reiner Farbwechsel (keine Bewegung)
  // und läuft deshalb auch bei prefers-reduced-motion
  Array.prototype.forEach.call(
    document.querySelectorAll(".hero h1, .section-head h2"),
    splitHeadingLetters
  );

  /* ---------- Scroll-Reveal (gestaffeltes Nachladen) ---------- */
  var revealEls = document.querySelectorAll(".reveal");

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        // Alles, was gleichzeitig sichtbar wird, in Lesereihenfolge staffeln
        var batch = entries.filter(function (entry) { return entry.isIntersecting; });
        batch.sort(function (a, b) {
          var dy = a.boundingClientRect.top - b.boundingClientRect.top;
          return dy !== 0 ? dy : a.boundingClientRect.left - b.boundingClientRect.left;
        });

        batch.forEach(function (entry, index) {
          var el = entry.target;
          var delay = Math.min(index * 110, 660);
          el.style.transitionDelay = delay + "ms";
          el.classList.add("is-visible");
          observer.unobserve(el);

          // Nach der Animation Reveal-Klassen entfernen, damit Hover-Effekte
          // der Karten wieder ihre eigenen, schnellen Transitions nutzen
          window.setTimeout(function () {
            el.style.transitionDelay = "";
            el.classList.remove("reveal", "reveal-delay-1", "reveal-delay-2", "reveal-delay-3");
          }, 1100 + delay);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Hero-Parallax ---------- */
  var heroImg = document.querySelector(".hero-media img");

  if (heroImg && !prefersReducedMotion) {
    var parallaxTicking = false;
    var updateParallax = function () {
      var y = Math.min(window.scrollY, window.innerHeight);
      heroImg.style.transform = "translateY(" + (y * 0.1).toFixed(1) + "px) scale(1.08)";
      parallaxTicking = false;
    };
    window.addEventListener(
      "scroll",
      function () {
        if (!parallaxTicking) {
          window.requestAnimationFrame(updateParallax);
          parallaxTicking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------- Nachhaltigkeits-Zahlen zählen hoch ---------- */
  var counters = document.querySelectorAll(".stat dd[data-count]");

  function animateCounter(el) {
    var target = parseInt(el.getAttribute("data-count"), 10);
    var prefix = el.getAttribute("data-prefix") || "";
    var suffix = el.getAttribute("data-suffix") || "";
    var duration = 1400;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = prefix + Math.round(eased * target) + suffix;
      if (progress < 1) window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  if (counters.length) {
    if ("IntersectionObserver" in window) {
      var counterObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              counterObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.6 }
      );
      counters.forEach(function (el) { counterObserver.observe(el); });
    } else {
      counters.forEach(animateCounter);
    }
  }

  /* ---------- Kontaktformular: Anfrage per E-Mail ---------- */
  /* Nicht jede Seite hat das Formular (Rechtsseiten, Shop) → Guard */
  var form = document.getElementById("contact-form");

  if (form) form.addEventListener("submit", function (event) {
    event.preventDefault();

    var required = form.querySelectorAll("[required]");
    var valid = true;

    required.forEach(function (field) {
      var ok = field.value.trim() !== "" && field.checkValidity();
      field.classList.toggle("is-invalid", !ok);
      if (!ok && valid) {
        field.focus();
        valid = false;
      }
    });

    if (!valid) return;

    var value = function (name) {
      var field = form.elements[name];
      return field && field.value.trim() ? field.value.trim() : "–";
    };

    var subject = value("topic") + " über ortaglia.wine – " + value("name");
    var body = [
      "Name: " + value("name"),
      "Unternehmen: " + value("company"),
      "E-Mail: " + value("email"),
      "Telefon: " + value("phone"),
      "Interesse: " + value("topic"),
      "",
      "Nachricht:",
      value("message"),
    ].join("\n");

    window.location.href =
      "mailto:willkommen@mywyne.de" +
      "?subject=" + encodeURIComponent(subject) +
      "&body=" + encodeURIComponent(body);
  });

  /* ---------- Produkt-Galerie: Thumbnail klicken → großes Bild tauschen ---------- */
  var galleryMain = document.getElementById("product-main-image");
  var galleryThumbs = document.querySelectorAll(".product-thumb");

  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (!full) return;
        galleryMain.src = full;
        var srcset = thumb.getAttribute("data-srcset");
        galleryMain.srcset = srcset || "";
        var alt = thumb.getAttribute("data-alt");
        if (alt !== null) galleryMain.alt = alt;
        galleryThumbs.forEach(function (other) {
          other.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  }
})();
